import React, { useState, useEffect, useRef } from "react";
import {
  Car,
  Gauge,
  AlertTriangle,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import InteriorIcon from "./Interior";
import { PiEngineBold } from "react-icons/pi";
import "bootstrap/dist/css/bootstrap.min.css";
import { GiCarSeat } from "react-icons/gi";
import { IoCarSportOutline } from "react-icons/io5";
import { TbBatteryAutomotiveFilled } from "react-icons/tb";
import Dropdown from "react-bootstrap/Dropdown";

function App() {
  const [currentStep, setCurrentStep] = useState(0);
  const [inspectionData, setInspectionData] = useState({
    basicDetails: {
      RegistrationNumber: { value: "", error: "" },
      ManufactureYear: { value: "", error: "" },
      Make: { value: "", error: "" },
      Model: { value: "", error: "" },
      variant: { value: "", error: "" },
      VehicleLocation: { value: "", error: "" },
      EngineNumber: { value: "", error: "" },
      ChassisNumber: { value: "", error: "" },
      // VehicleModel: { value: "", error: "" },
      FuelType: { value: "", error: "" },
      VehicleColor: { value: "", error: "" },
      BodyType: { value: "", error: "" },
      NoOfCylinder: { value: "", error: "" },
      CubicCapacityCC: { value: "", error: "" },
      SeatCapacity: { value: "", error: "" },
      NormsAndDescription: { value: "", error: "" },
      RcStatus: { value: "", error: "" },
      VehicleUsage: { value: "", error: "" },
      ReceiptNumber: { value: "", error: "" },
      Hypothecation: { value: "", error: "" },
      SpouseFatherName: { value: "", error: "" },
      KilometersDriven: { value: "", error: "" },
      FrontImage: { value: null, error: "" },

      Video: { value: null, error: "" },
      RegistrationYear: { value: "", error: "" },
      OwnerDetail: { value: "", error: "" },
      BlackListStatus: { value: "", error: "" },
      PuccNumber: { value: "", error: "" },
      TaxUpto: { value: "", error: "" },
      RcModified: { value: "", error: "" },
      RcOriginal: { value: "", error: "" },
      RcRegisteredAt: { value: "", error: "" },
      ownerName: { value: "", error: "" },
      RcMMVAndColorDiscrepancy: { value: "", error: "" },
      RcOwnerNameDiscrepancy: { value: "", error: "" },
      RcEngineChassisNoDiscrepancy: { value: "", error: "" },
      RcYearOfManRegOfRegDiscrepancy: { value: "", error: "" },
      InsuranceActive: { value: "", error: "" },
      Particular: { value: "", error: "" },
      RcChallanPending: { value: "", error: "" },
      CertificateIssuedBy: { value: "", error: "" },
      OwnerUpdate: { value: "", error: "" },
      ChallanDate: { value: "", error: "" },
      TaxFrom: { value: "", error: "" },
      TaxType: { value: "", error: "" },
      Make: { value: "", error: "" },
      ReceiptDate: { value: "", error: "" },
      TaxAmount: { value: "", error: "" },
      FinePenalty: { value: "", error: "" },
      VehicleSummary: { value: "", error: "" },
      AsOnStatus: { value: "", error: "" },
    },
    conditionGrading: {
      Dashboard: { value: "", error: "" },
      Brakes: { value: "", error: "" },
      Transmission: { value: "", error: "" },
      Electricals: { value: "", error: "" },
      Documents: { value: "", error: "" },
      Engine: { value: "", error: "" },
      Tyres: { value: "", error: "" },
      Battery: { value: "", error: "" },
      Exteriors: { value: "", error: "" },
      Interiors: { value: "", error: "" },
    },
    RCDetails: {
      StartingCondition: { value: "", error: "" },
      ExhaustSmoke: { value: "", error: "" },
      ServiceBrakeCondition: { value: "", error: "" },
      BrakePedalOperation: { value: "", error: "" },
      HandBrake: { value: "", error: "" },
      Wheels: { value: "", error: "" },
      WheelType: { value: "", error: "" },
      FrontTyreTread: { value: "", error: "" },
      RearTyreTread: { value: "", error: "" },
      TyreCuts: { value: "", error: "" },
      TyreCondition: { value: "", error: "" },
      Stepney: { value: "", error: "" },
      StepneyCondition: { value: "", error: "" },
      ClutchConditionPlay: { value: "", error: "" },
      GearEngagement: { value: "", error: "" },
      GearOperation: { value: "", error: "" },
      RcFitUpto: { value: "", error: "" },
      RcRegisteredAt: { value: "", error: "" },
      OilCondition: { value: "", error: "" },
      RcChallanPending: { value: "", error: "" },
      RcRegNumberMismatch: { value: "", error: "" },
      InsuranceCompany: { value: "", error: "" },
      InsuranceType: { value: "", error: "" },
      InsuranceFrom: { value: "", error: "" },
      InsuranceUpto: { value: "", error: "" },
      CoverNoteNo: { value: "", error: "" },
      Office: { value: "", error: "" },
      OwnerFrom: { value: "", error: "" },
    },
    mechanical: {
      BatteryCondition: { value: "", error: "" },
      TerminalCondition: { value: "", error: "" },
      BatteryWarranty: { value: "", error: "" },
      HVAC: { value: "", error: "" },
      Alternator: { value: "", error: "" },
      StarterMotor: { value: "", error: "" },
      MusicSystem: { value: "", error: "" },
      Horn: { value: "", error: "" },
      HeadLamps: { value: "", error: "" },
      FogLamps: { value: "", error: "" },
      TailLamps: { value: "", error: "" },
      ReverseLamp: { value: "", error: "" },
      HazardIndicator: { value: "", error: "" },
      TurnSignalLamps: { value: "", error: "" },
      BrakeLamp: { value: "", error: "" },
      HeadLightSwitch: { value: "", error: "" },
      DimAndDip: { value: "", error: "" },
      WiperSwitch: { value: "", error: "" },
      PowerWindow: { value: "", error: "" },
    },
    exteriors: {
      Paint: { value: "", error: "" },
      DentAndScratches: { value: "", error: "" },
      Rust: { value: "", error: "" },
      WindShield: { value: "", error: "" },
      SideDoorGlasses: { value: "", error: "" },
      RearGlasses: { value: "", error: "" },
      Wipers: { value: "", error: "" },
      RearViewMirrors: { value: "", error: "" },
      Bonnet: { value: "", error: "" },
      Grill: { value: "", error: "" },
      FrontBumper: { value: "", error: "" },
      FenderAndDoorRH: { value: "", error: "" },
      FenderAndDoorLH: { value: "", error: "" },
      ToolKit: { value: "", error: "" },
      UnderBody: { value: "", error: "" },
      Sunroof: { value: "", error: "" },
    },
    interiors: {
      DashboardCondition: { value: "", error: "" },
      SeatCover: { value: "", error: "" },
      SeatCondition: { value: "", error: "" },
      BeltStrapAndLock: { value: "", error: "" },
      SeatAdjustments: { value: "", error: "" },
      LocksAndHinges: { value: "", error: "" },
      FloorMattCondition: { value: "", error: "" },
      CabinLight: { value: "", error: "" },
      PanelLights: { value: "", error: "" },
      RoofCondition: { value: "", error: "" },
      AirbagIndicator: { value: "", error: "" },
      TurnSignalIndicator: { value: "", error: "" },
      RearParkingAssist: { value: "", error: "" },
      CruiseControl: { value: "", error: "" },
      OilPressureLight: { value: "", error: "" },
      EngineTemperatureWarning: { value: "", error: "" },
      EngineWarning: { value: "", error: "" },
      BatteryAlert: { value: "", error: "" },
    },
  });

  const [isMobile, setIsMobile] = useState(false);
  const TaxUptoRef = useRef(null);
  const InsuranceFromRef = useRef(null);
  const InsuranceUptoRef = useRef(null);

  const handleInputChange = (section, field, value) => {
    let error = "";

    if (
      field === "ChassisNumber" &&
      !/^[A-Z]{5}[0-9]{3}[A-Z]{3}[0-9]{6}$/.test(value)
    ) {
      error =
        "Chassis number must be in the format 5 letters, 3 numbers, 3 letters, 6 numbers.";
    } else if (
      field === "EngineNumber" &&
      !/^[A-Z][0-9][A-Z]{4}[0-9]{6}$/.test(value)
    ) {
      error =
        "Engine number must be in the format 1 letter, 1 number, 4 letters, 6 numbers.";
    } else if (
      field === "RegistrationNumber" &&
      !/^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/.test(value)
    ) {
      error =
        "Registration number must be in the format 2 letters, 2 numbers, 2 letters, 4 numbers.";
    } else if (
      [
        "KilometersDriven",
        "CoverNoteNo",
        "TaxAmount",
        "CubicCapacityCC",
        "SeatCapacity",
        "NoOfCylinder",
      ].includes(field) &&
      !/^[0-9]*$/.test(value)
    ) {
      error = "Only numbers are allowed.";
      value = value.replace(/[^0-9]/g, "");
    } else if (
      [
        "CertificateIssuedBy",
        "FinePenalty",
        "Hypothecation",
        "ownerName",
        "Make",
        "Hypothecation",
        "RcRegisteredAt",
        "VehicleLocation",
        "OwnerUpdate",
        "VehicleSummary",
        "SpouseFatherName",
        "Particular",
        "InsuranceCompany",
        "Office",
      ].includes(field) &&
      /\d/.test(value)
    ) {
      error = "Only alphabetic characters are allowed.";
      value = value.replace(/[0-9]/g, "");
    }

    setInspectionData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: { value, error },
      },
    }));
  };

  const handleFileChange = (section, field, event) => {
    const file = event.target.files[0];
    setInspectionData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: { value: file, error: "" },
      },
    }));
  };

  const handleNext = () => {
    const currentSection = sections[currentStep].key;
    const currentData = inspectionData[currentSection];
    const isValid = Object.values(currentData).every(
      (field) => field.value !== "" && field.error === ""
    );

    if (isValid) {
      if (currentStep < sections.length - 1) {
        setCurrentStep((prev) => prev + 1);
      }
    } else {
      setInspectionData((prev) => {
        const updatedData = { ...prev };
        Object.keys(currentData).forEach((field) => {
          if (currentData[field].value === "") {
            updatedData[currentSection][field].error =
              "This field is required.";
          }
        });
        return updatedData;
      });
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleSubmit = async () => {
    const formData = {
      auctionListId: "AUCTION123",
      inspectionReport: mapInspectionDataToAPIFormat(),
    };
    try {
      const response = await fetch(
        "http://localhost:8080/api/auction-data/add",
        {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href, // Optional: full URL
          },
          body: JSON.stringify(formData),
        }
      );
      if (response.ok) {
        console.log("Form submitted successfully");
      } else {
        console.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const mapInspectionDataToAPIFormat = () => {
    const formData = {
      registrationNumber:
        inspectionData.basicDetails.RegistrationNumber?.value || "",
      makeYear: Number(
        inspectionData.basicDetails.ManufactureYear?.value || ""
      ),
      vehicleLocation: inspectionData.basicDetails.VehicleLocation?.value || "",
      engineNumber: inspectionData.basicDetails.EngineNumber?.value || "",
      chassisNumber: inspectionData.basicDetails.ChassisNumber?.value || "",

      regYear: inspectionData.basicDetails.RegistrationYear?.value || "",
      insuranceValidity: inspectionData.RCDetails.InsuranceUpto?.value || "",
      valuationPrice: inspectionData.basicDetails.ValuationPrice?.value || "",
      // carModel: `${inspectionData.basicDetails?.Make?.value || ""} ${
      //   inspectionData.basicDetails?.VehicleModel?.value || ""
      // }`.trim(),

      carModel: `${inspectionData.basicDetails?.Make?.value || ""} ${
        inspectionData.basicDetails?.Model?.value || ""
      } ${inspectionData.basicDetails?.variant?.value || ""}`.trim(),

      fuelType: inspectionData.basicDetails.FuelType?.value || "",
      kilometerDriven:
        inspectionData.basicDetails.KilometersDriven?.value || "",
      vehicleColor: inspectionData.basicDetails.VehicleColor?.value || "",
      ownerDetails: inspectionData.basicDetails.OwnerDetail?.value || "",
      rcStatus: inspectionData.basicDetails.RcStatus?.value || "",
      blackListStatus:
        inspectionData.basicDetails.BlackListStatus?.value == "Yes"
          ? "Yes"
          : inspectionData.basicDetails.BlackListStatus?.value == "No"
          ? "No"
          : "",
      NormsAndDescription:
        inspectionData.basicDetails.NormsAndDescription?.value || "",
      CertificateIssuedBy:
        inspectionData.basicDetails.CertificateIssuedBy?.value || "",
      RcRegisteredAt: inspectionData.RCDetails.RcRegisteredAt?.value || "",
      carConditionGrades: [
        {
          component: "Dashboard",
          grade: inspectionData.conditionGrading.Dashboard?.value || "N/A",
        },
        {
          component: "Exteriors",
          grade: inspectionData.conditionGrading.Exteriors?.value || "N/A",
        },
        {
          component: "Engine",
          grade: inspectionData.conditionGrading.Engine?.value || "N/A",
        },
        {
          component: "Transmission",
          grade: inspectionData.conditionGrading.Transmission?.value || "N/A",
        },
        {
          component: "Brakes",
          grade: inspectionData.conditionGrading.Brakes?.value || "N/A",
        },
        {
          component: "Electricals",
          grade: inspectionData.conditionGrading.Electricals?.value || "N/A",
        },
        {
          component: "Tyres",
          grade: inspectionData.conditionGrading.Tyres?.value || "N/A",
        },
        {
          component: "Battery",
          grade: inspectionData.conditionGrading.Battery?.value || "N/A",
        },
        {
          component: "Documents",
          grade: inspectionData.conditionGrading.Documents?.value || "N/A",
        },
        {
          component: "Interiors",
          grade: inspectionData.conditionGrading.Interiors?.value || "N/A",
        },
      ],
      otherVehicleDetails: [
        {
          label: "Body Type",
          value: inspectionData.basicDetails.BodyType?.value || "",
        },
        {
          label: "No. of Cylinders",
          value: inspectionData.basicDetails.NoOfCylinder?.value || "",
        },
        {
          label: "Cubic Capacity",
          value: inspectionData.basicDetails.CubicCapacityCC?.value || "",
        },
        {
          label: "Seat Capacity",
          value: inspectionData.basicDetails.SeatCapacity?.value || "",
        },
        {
          label: "Norms Description",
          value: inspectionData.basicDetails.NormsAndDescription?.value || "",
        },
        {
          label: "PUCC Number",
          value: inspectionData.basicDetails.PuccNumber?.value || "",
        },
        {
          label: "PUCC upto",
          value: inspectionData.basicDetails.TaxUpto?.value || "",
        },
        {
          label: "RC value",
          value: inspectionData.basicDetails.RcStatus?.value || "",
        },
      ],
      additionalDetails: [
        {
          label: "Vehicle Usage",
          value: inspectionData.basicDetails.VehicleUsage?.value || "",
        },
        {
          label: "Certificate Issued By",
          value: inspectionData.basicDetails.CertificateIssuedBy?.value || "",
        },
        {
          label: "HPA",
          value: inspectionData.basicDetails.Hypothecation?.value || "",
        },
        {
          label: "RC Registered at",
          value: inspectionData.basicDetails.RcRegisteredAt?.value || "",
        },
        {
          label: "As on value",
          value: inspectionData.basicDetails.RegistrationYear?.value || "",
        },
        {
          label: "Current City",
          value: inspectionData.basicDetails.VehicleLocation?.value || "",
        },
        {
          label: "Permanent City",
          value: inspectionData.basicDetails.VehicleLocation?.value || "",
        },
        {
          label: "Spouse/Father Name",
          value: inspectionData.basicDetails.SpouseFatherName?.value || "",
        },
        {
          label: "RC Fit Upto",
          value: inspectionData.RCDetails.RcFitUpto?.value || "",
        },
        {
          label: "Tax upto",
          value: inspectionData.basicDetails.TaxUpto?.value || "",
        },
        {
          label: "RC NOC value",
          value: inspectionData.basicDetails.RcStatus?.value || "",
        },
      ],
      rcChangesHistory: [
        {
          sNo: 1,
          receiptNumber:
            inspectionData.basicDetails.RegistrationNumber?.value || "",
          receiptDate:
            inspectionData.basicDetails.RegistrationYear?.value || "",
          particular: "Service/User Charge",
          office: inspectionData.RCDetails.Office?.value || "",
        },
      ],
      insuranceDetails: [
        {
          sNo: 1,
          insuranceCompany:
            inspectionData.RCDetails.InsuranceCompany?.value || "",
          insuranceType: inspectionData.RCDetails.InsuranceType?.value || "",
          insuranceFrom: inspectionData.RCDetails.InsuranceFrom?.value || "",
          insuranceUpto: inspectionData.RCDetails.InsuranceUpto?.value || "",
          coverNoteNo: inspectionData.RCDetails.CoverNoteNo?.value || "",
          office: inspectionData.RCDetails.Office?.value || "",
        },
      ],
      ownershipHistoryDetails: [
        {
          sNo: 1,
          ownerName: inspectionData.basicDetails.OwnerDetail?.value || "",
          ownerFrom: inspectionData.basicDetails.RegistrationYear?.value || "",
          ownerUpdate: "-",
          fatherHusbandName:
            inspectionData.basicDetails.SpouseFatherName?.value || "",
        },
      ],
      taxDetails: [
        {
          sNo: 1,
          receiptNo: inspectionData.basicDetails.PuccNumber?.value || "",
          taxFrom: inspectionData.basicDetails.RegistrationYear?.value || "",
          taxUpto: inspectionData.basicDetails.TaxUpto?.value || "",
          taxType: "Car tax",
          challanDate:
            inspectionData.basicDetails.RegistrationYear?.value || "",
          taxAmount: "23459",
          finePenalty: "fine",
          office: inspectionData.RCDetails.Office?.value || "",
        },
      ],
      vehicleDetailsPhygital: [
        {
          label: "RC Modified",
          value:
            inspectionData.basicDetails.RcModified?.value == "Yes"
              ? true
              : inspectionData.basicDetails.RcModified?.value == "No"
              ? false
              : "",
        },
        {
          label: "RC Original",
          value:
            inspectionData.basicDetails.RcOriginal?.value == "Yes"
              ? true
              : inspectionData.basicDetails.RcOriginal?.value == "No"
              ? false
              : "",
        },
        {
          label: "RC Reg Number Mismatch",
          value:
            inspectionData.RCDetails.RcRegNumberMismatch?.value == "Yes"
              ? true
              : inspectionData.RCDetails.RcRegNumberMismatch?.value == "No"
              ? false
              : "",
        },
        {
          label: "RC Owner Name Discrepancy",
          value:
            inspectionData.basicDetails.RcOwnerNameDiscrepancy?.value == "Yes"
              ? true
              : inspectionData.basicDetails.RcOwnerNameDiscrepancy?.value ==
                "No"
              ? false
              : "",
        },
        {
          label: "RC Engine/Chassis No. Discrepancy",
          value:
            inspectionData.basicDetails.RcEngineChassisNoDiscrepancy?.value ==
            "Yes"
              ? true
              : inspectionData.basicDetails.RcEngineChassisNoDiscrepancy
                  ?.value == "No"
              ? false
              : "",
        },
        {
          label: "RC Year of Manu/Reg of Reg Discrepancy",
          value:
            inspectionData.basicDetails.RcYearOfManRegOfRegDiscrepancy?.value ==
            "Yes"
              ? true
              : inspectionData.basicDetails.RcYearOfManRegOfRegDiscrepancy
                  ?.value == "No"
              ? false
              : "",
        },
        {
          label: "Insurance Active",
          value:
            inspectionData.basicDetails.InsuranceActive?.value == "Yes"
              ? true
              : inspectionData.basicDetails.InsuranceActive?.value == "No"
              ? false
              : "",
        },
        {
          label: "RC Challan Pending",
          value:
            inspectionData.basicDetails.RcChallanPending?.value == "Yes"
              ? true
              : inspectionData.basicDetails.RcChallanPending?.value == "No"
              ? false
              : "",
        },
        {
          label: "RC MMV & COLOUR DISCREPANCY",
          value:
            inspectionData.basicDetails.RcMMVAndColorDiscrepancy?.value == "Yes"
              ? true
              : inspectionData.basicDetails.RcMMVAndColorDiscrepancy?.value ==
                "No"
              ? false
              : "",
        },
      ],
      interiorDetails: [
        {
          label: "Dashboard Condition",
          value:
            inspectionData.interiors.DashboardCondition?.value == "Good"
              ? true
              : inspectionData.interiors.DashboardCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Seat cover",
          value:
            inspectionData.interiors.SeatCover?.value == "Yes"
              ? true
              : inspectionData.interiors.SeatCover?.value == "No"
              ? false
              : "",
        },
        {
          label: "Seat Condition",
          value:
            inspectionData.interiors.SeatCondition?.value == "Good"
              ? true
              : inspectionData.interiors.SeatCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Seat Adjustments",
          value:
            inspectionData.interiors.SeatAdjustments?.value == "Good"
              ? true
              : inspectionData.interiors.SeatAdjustments?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Locks & Hinges",
          value:
            inspectionData.interiors.LocksAndHinges?.value == "Yes"
              ? true
              : inspectionData.interiors.LocksAndHinges?.value == "No"
              ? false
              : "",
        },
        {
          label: "Floor Matt Condition",
          value:
            inspectionData.interiors.FloorMattCondition?.value == "Good"
              ? true
              : inspectionData.interiors.FloorMattCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Cabin Light",
          value:
            inspectionData.interiors.CabinLight?.value == "Good"
              ? true
              : inspectionData.interiors.CabinLight?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Panel Light",
          value:
            inspectionData.interiors.PanelLights?.value == "Good"
              ? true
              : inspectionData.interiors.PanelLights?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Roof Condition",
          value:
            inspectionData.interiors.RoofCondition?.value == "Yes"
              ? true
              : inspectionData.interiors.RoofCondition?.value == "No"
              ? false
              : "",
        },
        {
          label: "Airbag",
          value:
            inspectionData.interiors.AirbagIndicator?.value == "Yes"
              ? true
              : inspectionData.interiors.AirbagIndicator?.value == "No"
              ? false
              : "",
        },
        {
          label: "Cruise Control",
          value:
            inspectionData.interiors.CruiseControl?.value == "Yes"
              ? true
              : inspectionData.interiors.CruiseControl?.value == "No"
              ? false
              : "",
        },
        {
          label: "BeltStrapAndLock",
          value:
            inspectionData.interiors.BeltStrapAndLock?.value == "Good"
              ? true
              : inspectionData.interiors.BeltStrapAndLock?.value == "Bad"
              ? false
              : "",
        },
      ],
      exteriorDetails: [
        {
          label: "Paint",
          value:
            inspectionData.exteriors.Paint?.value == "Good"
              ? true
              : inspectionData.exteriors.Paint?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Dent & Scratches",
          value:
            inspectionData.exteriors.DentAndScratches?.value == "Yes"
              ? true
              : inspectionData.exteriors.DentAndScratches?.value == "No"
              ? false
              : "",
        },
        {
          label: "Rust",
          value:
            inspectionData.exteriors.Rust?.value == "Good"
              ? true
              : inspectionData.exteriors.Rust?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Wind Shield",
          value:
            inspectionData.exteriors.WindShield?.value == "Good"
              ? true
              : inspectionData.exteriors.WindShield?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Side Door Glasses",
          value:
            inspectionData.exteriors.SideDoorGlasses?.value == "Good"
              ? true
              : inspectionData.exteriors.SideDoorGlasses?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Rear Glasses",
          value:
            inspectionData.exteriors.RearGlasses?.value == "Good"
              ? true
              : inspectionData.exteriors.RearGlasses?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Wipers",
          value:
            inspectionData.exteriors.Wipers?.value == "Good"
              ? true
              : inspectionData.exteriors.Wipers?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Rear-view Mirrors",
          value:
            inspectionData.exteriors.RearViewMirrors?.value == "Good"
              ? true
              : inspectionData.exteriors.RearViewMirrors?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Bonnet",
          value:
            inspectionData.exteriors.Bonnet?.value == "Good"
              ? true
              : inspectionData.exteriors.Bonnet?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Grill",
          value:
            inspectionData.exteriors.Grill?.value == "Good"
              ? true
              : inspectionData.exteriors.Grill?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Front Bumper",
          value:
            inspectionData.exteriors.FrontBumper?.value == "Good"
              ? true
              : inspectionData.exteriors.FrontBumper?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Fender & Door RH",
          value:
            inspectionData.exteriors.FenderAndDoorRH?.value == "Good"
              ? true
              : inspectionData.exteriors.FenderAndDoorRH?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Fender & Door LH",
          value:
            inspectionData.exteriors.FenderAndDoorLH?.value == "Good"
              ? true
              : inspectionData.exteriors.FenderAndDoorLH?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Rear bumper",
          value:
            inspectionData.exteriors.RearGlasses?.value == "Good"
              ? true
              : inspectionData.exteriors.RearGlasses?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Under Body",
          value:
            inspectionData.exteriors.UnderBody?.value == "Good"
              ? true
              : inspectionData.exteriors.UnderBody?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Sunroof",
          value:
            inspectionData.exteriors.Sunroof?.value == "Yes"
              ? true
              : inspectionData.exteriors.Sunroof?.value == "No"
              ? false
              : "",
        },
        {
          label: "Tool Kit",
          value:
            inspectionData.exteriors.ToolKit?.value == "Yes"
              ? true
              : inspectionData.exteriors.ToolKit?.value == "No"
              ? false
              : "",
        },
      ],
      engineBrakesTyresDetails: [
        {
          label: "Starting Condition",
          value:
            inspectionData.RCDetails.StartingCondition?.value == "Good"
              ? true
              : inspectionData.RCDetails.StartingCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Oil Condition",
          value:
            inspectionData.RCDetails.OilCondition?.value == "Good"
              ? true
              : inspectionData.RCDetails.OilCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Exhaust Smoke ",
          value:
            inspectionData.RCDetails.ExhaustSmoke?.value == "Yes"
              ? true
              : inspectionData.RCDetails.ExhaustSmoke?.value == "No"
              ? false
              : "",
        },
        {
          label: "Service Brake Condition",
          value:
            inspectionData.RCDetails.ServiceBrakeCondition?.value == "Good"
              ? true
              : inspectionData.RCDetails.ServiceBrakeCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Brake Pedal Operation",
          value:
            inspectionData.RCDetails.BrakePedalOperation?.value == "Good"
              ? true
              : inspectionData.RCDetails.BrakePedalOperation?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Hand Brake",
          value:
            inspectionData.RCDetails.HandBrake?.value == "Good"
              ? true
              : inspectionData.RCDetails.HandBrake?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Wheels Type",
          value:
            inspectionData.RCDetails.WheelType?.value == "Alloys"
              ? "Alloys"
              : inspectionData.RCDetails.WheelType?.value == "Normal"
              ? "Normal"
              : "",
        },
        {
          label: "Wheels",
          value:
            inspectionData.RCDetails.Wheels?.value == "Yes"
              ? true
              : inspectionData.RCDetails.Wheels?.value == "No"
              ? false
              : "",
        },
        {
          label: "Front Tyre Tread",
          value:
            inspectionData.RCDetails.FrontTyreTread?.value == "Good"
              ? true
              : inspectionData.RCDetails.FrontTyreTread?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Rear Tyre Tread",
          value:
            inspectionData.RCDetails.RearTyreTread?.value == "Good"
              ? true
              : inspectionData.RCDetails.RearTyreTread?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Tyre Cuts",
          value:
            inspectionData.RCDetails.TyreCuts?.value == "Yes"
              ? true
              : inspectionData.RCDetails.TyreCuts?.value == "No"
              ? false
              : "",
        },
        {
          label: "Tyre Condition",
          value:
            inspectionData.RCDetails.TyreCondition?.value == "Good"
              ? true
              : inspectionData.RCDetails.TyreCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Stepney",
          value:
            inspectionData.RCDetails.Stepney?.value == "Good"
              ? true
              : inspectionData.RCDetails.Stepney?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Stepney Condition",
          value:
            inspectionData.RCDetails.StepneyCondition?.value == "Good"
              ? true
              : inspectionData.RCDetails.StepneyCondition?.value == "Bad"
              ? false
              : "",
        },
      ],
      dashboardIndicators: [
        {
          label: "Oil Pressure Light",
          value:
            inspectionData.interiors.OilPressureLight?.value == "Yes"
              ? true
              : inspectionData.interiors.OilPressureLight?.value == "No"
              ? false
              : "",
        },
        {
          label: "Engine Temperature Warning",
          value:
            inspectionData.interiors.EngineTemperatureWarning?.value == "Yes"
              ? true
              : inspectionData.interiors.EngineTemperatureWarning?.value == "No"
              ? false
              : "",
        },
        {
          label: "Engine Warning",
          value:
            inspectionData.interiors.EngineWarning?.value == "Yes"
              ? true
              : inspectionData.interiors.EngineWarning?.value == "No"
              ? false
              : "",
        },
        {
          label: "Battery Alert",
          value:
            inspectionData.interiors.BatteryAlert?.value == "Yes"
              ? true
              : inspectionData.interiors.BatteryAlert?.value == "No"
              ? false
              : "",
        },
        {
          label: "Airbag Indicator",
          value:
            inspectionData.interiors.AirbagIndicator?.value == "Yes"
              ? true
              : inspectionData.interiors.AirbagIndicator?.value == "No"
              ? false
              : "",
        },
        {
          label: "Turn Signal Indicator",
          value:
            inspectionData.interiors.TurnSignalIndicator?.value == "Yes"
              ? true
              : inspectionData.interiors.TurnSignalIndicator?.value == "No"
              ? false
              : "",
        },
        {
          label: "Rear Parking Assist",
          value:
            inspectionData.interiors.RearParkingAssist?.value == "Yes"
              ? true
              : inspectionData.interiors.RearParkingAssist?.value == "No"
              ? false
              : "",
        },
      ],
      batteryElectricalsDetails: [
        {
          label: "Battery Condition",
          value:
            inspectionData.mechanical.BatteryCondition?.value == "Good"
              ? true
              : inspectionData.mechanical.BatteryCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Terminal Condition",
          value:
            inspectionData.mechanical.TerminalCondition?.value == "Good"
              ? true
              : inspectionData.mechanical.TerminalCondition?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Battery Warranty",
          value:
            inspectionData.mechanical.BatteryWarranty?.value == "Yes"
              ? true
              : inspectionData.mechanical.BatteryWarranty?.value == "No"
              ? false
              : "",
        },
        {
          label: "HVAC",
          value:
            inspectionData.mechanical.HVAC?.value == "Good"
              ? true
              : inspectionData.mechanical.HVAC?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Alternator",
          value:
            inspectionData.mechanical.Alternator?.value == "Good"
              ? true
              : inspectionData.mechanical.Alternator?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Starter Motor",
          value:
            inspectionData.mechanical.StarterMotor?.value == "Yes"
              ? true
              : inspectionData.mechanical.StarterMotor?.value == "No"
              ? false
              : "",
        },
        {
          label: "Music System",
          value:
            inspectionData.mechanical.MusicSystem?.value == "Good"
              ? true
              : inspectionData.mechanical.MusicSystem?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Horn",
          value:
            inspectionData.mechanical.Horn?.value == "Good"
              ? true
              : inspectionData.mechanical.Horn?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Head Lamps",
          value:
            inspectionData.mechanical.HeadLamps?.value == "Good"
              ? true
              : inspectionData.mechanical.HeadLamps?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Fog Lamps",
          value:
            inspectionData.mechanical.FogLamps?.value == "Good"
              ? true
              : inspectionData.mechanical.FogLamps?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Tail Lamps",
          value:
            inspectionData.mechanical.TailLamps?.value == "Good"
              ? true
              : inspectionData.mechanical.TailLamps?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Reverse Lamp",
          value:
            inspectionData.mechanical.ReverseLamp?.value == "Good"
              ? true
              : inspectionData.mechanical.ReverseLamp?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Hazard Indicator",
          value:
            inspectionData.mechanical.HazardIndicator?.value == "Good"
              ? true
              : inspectionData.mechanical.HazardIndicator?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Turn Signal Lamps",
          value:
            inspectionData.mechanical.TurnSignalLamps?.value == "Good"
              ? true
              : inspectionData.mechanical.TurnSignalLamps?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Brake Lamp",
          value:
            inspectionData.mechanical.BrakeLamp?.value == "Yes"
              ? true
              : inspectionData.mechanical.BrakeLamp?.value == "No"
              ? false
              : "",
        },
        {
          label: "Head Light Switch",
          value:
            inspectionData.mechanical.HeadLightSwitch?.value == "Good"
              ? true
              : inspectionData.mechanical.HeadLightSwitch?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Dim and Dip",
          value:
            inspectionData.mechanical.DimAndDip?.value == "Good"
              ? true
              : inspectionData.mechanical.DimAndDip?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Wiper Switch",
          value:
            inspectionData.mechanical.WiperSwitch?.value == "Good"
              ? true
              : inspectionData.mechanical.WiperSwitch?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Power Window",
          value:
            inspectionData.mechanical.PowerWindow?.value == "Yes"
              ? true
              : inspectionData.mechanical.PowerWindow?.value == "No"
              ? false
              : "",
        },
      ],
      clutchTransmissionDetails: [
        {
          label: "Clutch Condition/Play",
          value:
            inspectionData.RCDetails.ClutchConditionPlay?.value == "Good"
              ? true
              : inspectionData.RCDetails.ClutchConditionPlay?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Gear Engagement",
          value:
            inspectionData.RCDetails.GearEngagement?.value == "Good"
              ? true
              : inspectionData.RCDetails.GearEngagement?.value == "Bad"
              ? false
              : "",
        },
        {
          label: "Gear Operation",
          value:
            inspectionData.RCDetails.GearOperation?.value == "Good"
              ? true
              : inspectionData.RCDetails.GearOperation?.value == "Bad"
              ? false
              : "",
        },
      ],
    };

    return formData;
  };

  // const UploadComponent = () => {
  //   const [showPopup, setShowPopup] = useState(false);

  //   const handleUploadClick = () => {
  //     setShowPopup(true);
  //   };

  //   const handleOpenCamera = async (type) => {
  //     try {
  //       const stream = await navigator.mediaDevices.getUserMedia({
  //         video: true,
  //         audio: type === "video",
  //       });
  //       // Handle the stream (e.g., display it in a video element)
  //       const mediaRecorder = new MediaRecorder(stream);
  //       mediaRecorder.ondataavailable = (event) => {
  //         if (event.data.size > 0) {
  //           // Handle the recorded data (e.g., upload it)
  //           console.log(event.data);
  //         }
  //       };
  //       mediaRecorder.start();
  //       // Stop recording after a certain duration or based on user action
  //       setTimeout(() => mediaRecorder.stop(), 5000); // Example: stop after 5 seconds
  //     } catch (error) {
  //       console.error("Error accessing media devices.", error);
  //     }
  //   };

  //   const handleSelectFromGallery = (type) => {
  //     const input = document.createElement("input");
  //     input.type = "file";
  //     input.accept = type === "image" ? "image/*" : "video/*";
  //     input.onchange = (event) => {
  //       const file = event.target.files[0];
  //       if (file) {
  //         // Handle the selected file (e.g., upload it)
  //         console.log(file);
  //       }
  //     };
  //     input.click();
  //   };

  //   return (
  //     <div>
  //       <button onClick={handleUploadClick}>Upload</button>
  //       {showPopup && (
  //         <div className="popup">
  //           <button onClick={() => handleOpenCamera("image")}>
  //             Open Camera (Image)
  //           </button>
  //           <button onClick={() => handleOpenCamera("video")}>
  //             Open Camera (Video)
  //           </button>
  //           <button onClick={() => handleSelectFromGallery("image")}>
  //             Select from Gallery (Image)
  //           </button>
  //           <button onClick={() => handleSelectFromGallery("video")}>
  //             Select from Gallery (Video)
  //           </button>
  //           <button onClick={() => setShowPopup(false)}>Cancel</button>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  const App = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [cameraOpen, setCameraOpen] = useState(false);

    const openPopup = () => {
      setShowPopup(true);
    };

    const closePopup = () => {
      setShowPopup(false);
    };

    const openCamera = () => {
      setCameraOpen(true);
      setShowPopup(false);
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            const video = document.getElementById("cameraVideo");
            video.srcObject = stream;
            video.play();
          })
          .catch((error) => {
            console.error("Error accessing camera:", error);
          });
      }
    };

    const openGallery = () => {
      setShowPopup(false);
      document.getElementById("fileInput").click();
    };

    const handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        // Handle the selected file
        console.log("Selected file:", file);
      }
    };

    return (
      <div>
        <button onClick={openPopup}>Add Photo</button>

        {showPopup && (
          <div className="popup">
            <button onClick={openCamera}>Open Camera</button>
            <button onClick={openGallery}>Select from Gallery</button>
            <button onClick={closePopup}>Cancel</button>
          </div>
        )}

        {cameraOpen && (
          <div className="camera">
            <video id="cameraVideo" width="640" height="480" autoPlay></video>
            <div className="guideline">
              {/* Add your guideline overlay here */}
            </div>
          </div>
        )}

        <input
          type="file"
          id="fileInput"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>
    );
  };

  const renderSection = (title, section, data, icon) => (
    <div className="bg-white p-4 rounded shadow mb-4">
      <div className="d-flex align-items-center gap-2 mb-2 pb-2 border-bottom border-secondary">
        {icon}
        <h5 className="m-0 text fw-bold" style={{ color: "red" }}>
          {title}
        </h5>
      </div>
      <div className="row g-1">
        {data &&
          Object.entries(data).map(([field, { value, error }]) => (
            <div key={field} className="col-md-6">
              <label className="form-label">
                {field.replace(/([A-Z])/g, " $1").trim()}
              </label>

              {field === "ManufactureYear" ? (
                <Dropdown
                  onSelect={(e) => handleInputChange(section, field, e)}
                >
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    className="dropdown-toggle-left-align"
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    {value || "Select Year"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {Array.from({ length: 50 }, (_, i) => (
                      <Dropdown.Item
                        key={i}
                        eventKey={new Date().getFullYear() - i}
                      >
                        {new Date().getFullYear() - i}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              ) : field === "BodyType" ? (
                <Dropdown
                  onSelect={(e) => handleInputChange(section, field, e)}
                >
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    className="dropdown-toggle-left-align"
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    {value || "Select Body Type"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {[
                      "Sedan",
                      "Hatchback",
                      "Coupe",
                      "Convertible",
                      "Wagon",
                      "Liftback",
                    ].map((option) => (
                      <Dropdown.Item key={option} eventKey={option}>
                        {option}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              ) : field === "TaxType" ? (
                <div>
                  {["Road Safety Tax/Cess", "MV Tax"].map((option) => (
                    <div key={option} className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        style={{ border: "2px solid red" }}
                        name={`${section}-${field}`}
                        id={`${field}-${option}`}
                        value={option}
                        checked={value === option}
                        onChange={(e) =>
                          handleInputChange(section, field, e.target.value)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${field}-${option}`}
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              ) : [
                  "RcFitUpto",
                  "RegistrationYear",
                  "TaxUpto",
                  "InsuranceFrom",
                  "InsuranceUpto",
                  "OwnerFrom",
                  "TaxFrom",
                  "ChallanDate",
                  "ReceiptDate",
                  "AsOnStatus",
                ].includes(field) ? (
                <input
                  type="date"
                  value={value || ""}
                  onChange={(e) =>
                    handleInputChange(section, field, e.target.value)
                  }
                  className="form-control"
                  onFocus={(e) => e.target.showPicker()}
                />
              ) : ["FrontImage", "BackImage", "Video"].includes(field) ? (
                <input
                  type="file"
                  accept={field === "Video" ? "video/*" : "image/*"}
                  capture="environment"
                  onChange={(e) => handleFileChange(section, field, e)}
                  className="form-control"
                />
              ) : [
                  "Dashboard",
                  "Brakes",
                  "Transmission",
                  "Electricals",
                  "Documents",
                  "Engine",
                  "Tyres",
                  "Battery",
                  "Interiors",
                  "Exteriors",
                ].includes(field) ? (
                <div>
                  {["A+", "A", "B", "C", "D"].map((option) => (
                    <div key={option} className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        style={{ border: "2px solid red" }}
                        name={`${section}-${field}`}
                        id={`${field}-${option}`}
                        value={option}
                        checked={value === option}
                        onChange={(e) =>
                          handleInputChange(section, field, e.target.value)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${field}-${option}`}
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              ) : [
                  "StartingCondition",
                  "HandBrake",
                  "HazardIndicator",
                  "BatteryCondition",
                  "BeltStrapAndLock",
                  "FrontTyreTread",
                  "RearTyreTread",
                  "OilCondition",
                  "Alternator",

                  "GearEngagement",
                  "GearOperation",
                  "ClutchConditionPlay",
                  "Brake",
                  "TyreCondition",
                  "Paint",
                  "WindShield",
                  "SideDoorGlasses",
                  "RearGlasses",
                  "Wipers",
                  "Bonnet",
                  "FrontBumper",
                  "Grill",
                  "HeadLamps",
                  "ServiceBrakeCondition",
                  "FogLamps",
                  "RearBumper",
                  "Dicky",
                  "HVAC",
                  "DashboardCondition",
                  "SeatCondition",
                  "SeatAdjustments",
                  "FloorMattCondition",
                  "PanelLights",
                  "TailLamps",
                  "ReverseLamp",
                  "MusicSystem",
                  "DimAndDip",
                  "TerminalCondition",
                  "Horn",
                  "TurnSignalLamps",

                  "HeadLightSwitch",
                  "RearViewMirrors",
                  "WiperSwitch",
                  "Stepney",
                  "CabinLight",
                  "UnderBody",
                  "Rust",
                  "BrakePedalOperation",
                  "FenderAndDoorRH",
                  "FenderAndDoorLH",
                  "StepneyCondition",
                  "WorkingCondition",
                ].includes(field) ? (
                <div>
                  {["Good", "Bad"].map((option) => (
                    <div key={option} className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        style={{ border: "2px solid red" }}
                        name={`${section}-${field}`}
                        id={`${field}-${option}`}
                        value={option}
                        checked={value === option}
                        onChange={(e) => {
                          console.log(section, field, e.target.value);
                          handleInputChange(section, field, e.target.value);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${field}-${option}`}
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              ) : [
                  "FuelType",
                  "VehicleColor",
                  "VehicleUsage",
                  "WheelType",
                  "ClutchConditionPlay",
                  "DentAndScratches",
                  "ToolKit",
                  "Sunroof",
                  "ExhaustSmoke",
                  "DashboardCondition",
                  "SeatCondition",
                  "SeatAdjustments",
                  "BrakeLamp",
                  "RcModified",
                  "RcOriginal",
                  "RcMMVAndColorDiscrepancy",
                  "RcEngineChassisNoDiscrepancy",
                  "InsuranceActive",
                  "BlackListStatus",
                  "RcOwnerNameDiscrepancy",
                  "RcYearOfManRegOfRegDiscrepancy",
                  "FloorMattCondition",
                  "PanelLights",
                  "OilPressureLight",
                  "EngineWarning",
                  "TyreCuts",
                  "RcChallanPending",
                  "AirbagIndicator",
                  "RearParkingAssist",
                  "CruiseControl",
                  "TurnSignalIndicator",
                  "BatteryAlert",
                  "EngineTemperatureWarning",
                  "RoofCondition",
                  "LocksAndHinges",

                  "SeatCover",
                  "BatteryWarranty",
                  "RcRegNumberMismatch",
                  "Wheels",

                  "TerminalCondition",
                  "StarterMotor",
                  "MusicSystem",
                  "Horn",
                  "PowerWindow",
                  "HeadLamps",

                  "TailLamps",

                  "Documents",
                  "Interior",
                ].includes(field) ? (
                <div>
                  {field === "VehicleColor"
                    ? ["White", "Black", "Red", "Grey", "Blue"].map(
                        (option) => (
                          <div key={option} className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              style={{ border: "2px solid red" }}
                              name={`${section}-${field}`}
                              id={`${field}-${option}`}
                              value={option}
                              checked={value === option}
                              onChange={(e) =>
                                handleInputChange(
                                  section,
                                  field,
                                  e.target.value
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`${field}-${option}`}
                            >
                              {option}
                            </label>
                          </div>
                        )
                      )
                    : field === "FuelType"
                    ? ["Petrol", "Diesel", "LPG", "CNG"].map((option) => (
                        <div key={option} className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            style={{ border: "2px solid red" }}
                            name={`${section}-${field}`}
                            id={`${field}-${option}`}
                            value={option}
                            checked={value === option}
                            onChange={(e) =>
                              handleInputChange(section, field, e.target.value)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${field}-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))
                    : field === "VehicleUsage"
                    ? ["Private", "Taxi"].map((option) => (
                        <div key={option} className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            style={{ border: "2px solid red" }}
                            name={`${section}-${field}`}
                            id={`${field}-${option}`}
                            value={option}
                            checked={value === option}
                            onChange={(e) =>
                              handleInputChange(section, field, e.target.value)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${field}-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))
                    : field === "WheelType"
                    ? ["Alloys", "Normal"].map((option) => (
                        <div key={option} className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            style={{ border: "2px solid red" }}
                            name={`${section}-${field}`}
                            id={`${field}-${option}`}
                            value={option}
                            checked={value === option}
                            onChange={(e) =>
                              handleInputChange(section, field, e.target.value)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${field}-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))
                    : ["Yes", "No"].map((option) => (
                        <div key={option} className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            style={{ border: "2px solid red" }}
                            name={`${section}-${field}`}
                            id={`${field}-${option}`}
                            value={option}
                            checked={value === option}
                            onChange={(e) =>
                              handleInputChange(section, field, e.target.value)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${field}-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                </div>
              ) : field == "RcStatus" ? (
                ["Active", "Inactive"].map((option) => (
                  <div key={option} className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      style={{ border: "2px solid red" }}
                      name={`${section}-${field}`}
                      id={`${field}-${option}`}
                      value={option}
                      checked={value === option}
                      onChange={(e) =>
                        handleInputChange(section, field, e.target.value)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`${field}-${option}`}
                    >
                      {option}
                    </label>
                  </div>
                ))
              ) : field === "InsuranceType" ? (
                ["Third Party", "Comprehensive"].map((option) => (
                  <div key={option} className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      style={{ border: "2px solid red" }}
                      name={`${section}-${field}`}
                      id={`${field}-${option}`}
                      value={option}
                      checked={value === option}
                      onChange={(e) =>
                        handleInputChange(section, field, e.target.value)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`${field}-${option}`}
                    >
                      {option}
                    </label>
                  </div>
                ))
              ) : field === "Model" ? (
                <Dropdown
                  onSelect={(e) => handleInputChange(section, field, e)}
                >
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    className="dropdown-toggle-left-align"
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    {value || "Select Model"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {[
                      "STILE",
                      "DB11",
                      "DB9",
                      "DBS",
                      "RAPIDE",
                      "MV12 VANTAGE",
                      "V8 VANTAGE",
                      "VANQUISH",
                      "A3",
                      "A4",
                      "A5",
                      "A6",
                      "A8L",
                      "Q3",
                      "Q7",
                      "City",
                      "BR-V",
                      "BRIO",
                      "AMAZE",
                      "ACCORD",
                      "AMBASSADOR",
                      "MONDEO ",
                      "IKON",
                      "FUSION",
                      "FIGO",
                      "FIESTA CLASSIC",
                      "FIESTA",
                      "ECOSPORT",
                      "CLASSIC",
                      "ASPIRE",
                      "FORCE ONE",
                      "UNO",
                      "CONTINENTAL FLYING SPUR",
                      "FORCE ONE",
                      "GURKHA",
                      "ENDEAVOUR",
                    ].map((option) => (
                      <Dropdown.Item key={option} eventKey={option}>
                        {option}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              ) : field === "variant" ? (
                <Dropdown
                  onSelect={(e) => handleInputChange(section, field, e)}
                >
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    className="dropdown-toggle-left-align"
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    {value || "Select Variant"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {[
                      "LE 7 STR",
                      "COUPE",
                      "LUXE",
                      "LE 6 STR",
                      "EVOLUTION",
                      "LUXE 7 STR",
                      "SD IESEL",
                      "EVOLUTION",
                      "V MT CNG COMPATIBLE",
                      "V AT (AVN)",
                      "V MT (AVN)",
                      "1.5 S MT",
                      "1.5 S AT",
                      "VOLANTE",
                      "35 TDI PREMIUM PLUS",
                      "35 TDI TECHNOLOGY",
                      "35 TFSI PREMIUM PLUS",
                      "35 TDI",
                      "1.8 TFSI MULTITRONIC TECHNOLOGY PACK",
                      "40TFSI",
                      "40 TDI",
                      "2.0 TDI (177BHP) TECHNOLOGY PACK ",
                      "3.0 TDI (286BHP) TECHNOLOGY PACK ",
                      "3.0 TDI QUATTRO PREMIUM PLUS",

                      " 1.5 S MT CNG",

                      "15 V MT EXCLUSIVE",
                      "V MT CNG COMPATIBLE",
                      "Maruti Suzuki",
                      "Hindustan Motors",
                    ].map((option) => (
                      <Dropdown.Item key={option} eventKey={option}>
                        {option}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              ) : field === "Model" ? (
                <Dropdown
                  onSelect={(e) => handleInputChange(section, field, e)}
                >
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    className="dropdown-toggle-left-align"
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    {value || "Select Model"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {[
                      "Hyundai",
                      "Kia",
                      "Genesis ",
                      "Tata Motors",
                      "Mahindra",
                      "Maruti Suzuki",
                      "Hindustan Motors",
                    ].map((option) => (
                      <Dropdown.Item key={option} eventKey={option}>
                        {option}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              ) : field === "Make" ? (
                <Dropdown
                  onSelect={(e) => handleInputChange(section, field, e)}
                >
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    className="dropdown-toggle-left-align"
                    style={{ width: "100%", textAlign: "left" }}
                  >
                    {value || "Select Make"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {[
                      "ASHOK LEYLAND",
                      "ASTON MARTIN",
                      "AUDI ",
                      "BENTLEY",
                      "BMW",
                      "BUGATTI",
                      "CATERHAM",
                      "CHEVROLET",
                      "DAEWOO",
                      "DATSUN",
                      "DC",
                      "EICHER POLARIS",
                      "FERRARI",
                      "FIAT",
                      "FORD",
                      "FORCE MOTORS",
                      "HONDA",
                      "HUMMER",
                      "HUNDAI",
                    ].map((option) => (
                      <Dropdown.Item key={option} eventKey={option}>
                        {option}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <input
                  type="text"
                  value={value}
                  onChange={(e) => {
                    console.log(section, field, e.target.value);
                    handleInputChange(section, field, e.target.value);
                  }}
                  className="form-control"
                />
              )}
              {error && <div className="text-danger">{error}</div>}
            </div>
          ))}
      </div>
    </div>
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const sections = [
    { title: "Details", key: "basicDetails", icon: <Car /> },
    { title: "Grading", key: "conditionGrading", icon: <Gauge /> },
    {
      title: "Drivetrain",
      key: "RCDetails",
      icon: <PiEngineBold size={20} />,
    },
    {
      title: "Elecs",
      key: "mechanical",
      icon: <TbBatteryAutomotiveFilled size={20} />,
    },
    {
      title: "Exterior",
      key: "exteriors",
      icon: <IoCarSportOutline size={20} />,
    },
    { title: "Interior", key: "interiors", icon: <GiCarSeat size={20} /> },
  ];

  const handleSectionClick = (index) => {
    setCurrentStep(index);
  };

  const handleFocus = (ref) => {
    if (ref.current) {
      ref.current.showPicker();
    }
  };

  return (
    <div className="cotainer pt-2 bg-light">
      <header className="text-center mb-4">
        <h1
          className="display-5 mb-2"
          style={{ color: "red", fontWeight: "bold" }}
        >
          Vehicle Inspection Form
        </h1>
        <p className="text" style={{ fontSize: "20px", color: "red" }}>
          Complete vehicle inspection checklist
        </p>
      </header>

      <div className="d-flex justify-content-around align-items-center mb-4 px-3 gap-2 bg-white">
        {sections.map((section, index) => (
          <div
            key={section.key}
            className="d-flex flex-column align-items-center gap-2 position-relative"
            onClick={() => handleSectionClick(index)}
            style={{ cursor: "pointer" }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{ fontSize: "5px" }}
            >
              {section.icon}
            </div>
            <span
              className={`small ${currentStep > index ? "green" : "red"}`}
              style={{
                color: currentStep > index ? "green" : "red",
                fontWeight: "450",

                fontSize: "16px",
                backgroundColor: "white",
              }}
            >
              {section.title}
            </span>
          </div>
        ))}
      </div>

      <div
        className="mb-4"
        style={{
          overflowY: "scroll",
          maxHeight: isMobile ? "600px" : "350px",
          paddingLeft: "3%",
          paddingRight: "3%",
        }}
      >
        {renderSection(
          sections[currentStep].title,
          sections[currentStep].key,
          inspectionData[sections[currentStep].key],
          sections[currentStep].icon
        )}
      </div>

      <div
        className={`d-flex justify-content-between ${
          isMobile ? "fixed-bottom bg-light p-3" : ""
        }`}
        style={{
          marginleft: isMobile ? "100%" : "30%",

          width: isMobile ? "90%" : "",
          height: isMobile ? "12%" : "",
        }}
      >
        {currentStep === 0 && <span></span>}
        {currentStep !== 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginRight: isMobile ? "" : "40px",
              // width: isMobile ? "00%" : "",
              // height: isMobile ? " 70px" : "",
            }}
          >
            <button
              onClick={handlePrev}
              className="btn btn-secondary"
              style={{ height: "40px" }}
            >
              <ChevronLeft /> Previous
            </button>
          </div>
        )}
        {currentStep === sections.length - 1 ? (
          <button
            onClick={handleSubmit}
            className="btn btn-danger"
            style={{
              height: "40px",
              width: isMobile ? "55%" : "",
              marginRight: isMobile ? "" : "2%",
              marginleft: isMobile ? "6%" : "",
            }}
          >
            Submit Inspection
          </button>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginRight: isMobile ? "" : "2%",
              // width: isMobile ? "90%" : "",
              // height: isMobile ? " 70px" : "",
            }}
          >
            <button
              onClick={handleNext}
              className="btn btn-danger"
              style={{ height: "40px" }}
            >
              Next <ChevronRight />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
